var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":_vm.dataCy}},_vm._l((_vm.items),function(item,index){return _c('OurAccordionItem',{key:item.name,ref:`item-${item.name}`,refInFor:true,attrs:{"title":item.title,"description":item.description,"name":item.name,"size":_vm.size,"data-cy":`${_vm.dataCy}-item-${index}`},on:{"itemClicked":_vm.onItemClicked}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }